import React from 'react';
import { IMeetingsJobDetails } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { IGenerateRoomsResultDTO } from '../../../api/rooms.dao';

const generatingRoomsJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<
    IMeetingsJobDetails,
    IGenerateRoomsResultDTO
>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IGenerateRoomsResultDTO>) => {
        return (
            <div className='alert-content'>
                <div className='alert-content__item'>{props.result.createdRoomsCount || 0} Rooms were created.</div>
                <div className='alert-content__item'>{props.result.meetingsAssignedToRoomsCount || 0} meetings were assigned to Rooms.</div>
                <div className='alert-content__item'>
                    {props.result.meetingsWithoutRoomsCount || 0} meetings still have no Room assigned because there is no matching Room.
                </div>
            </div>
        );
    },
    failedComponent: () => {
        return <>Creating & Assigning Rooms Failed</>;
    }
};

export { generatingRoomsJobProperties };
